import React, { useContext, useEffect, useState } from 'react';
import {
  ApplicationState,
  AppState,
  CaseSettingsActionCreators,
  CaseSettingsState,
  VehicleActionCreators,
  VehicleState
} from '../../store';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { withSnackbar, ProviderContext } from 'notistack';
import { TariffPercentResponse } from '../../interfaces/Case';
import { Order } from '../../interfaces/Order';
import 'moment/locale/en-gb';
import 'moment/locale/ro';
import OrderDetailsNew from './OrderDetailsNew';

type OrderPageNewProps = {
  caseSettingsState: CaseSettingsState;
  vehicleState: VehicleState;
  appState: AppState;
} & typeof CaseSettingsActionCreators &
  typeof VehicleActionCreators &
  ProviderContext &
  RouteComponentProps<{ id: string }>;

const OrderPageNew: React.FC<OrderPageNewProps> = (props) => {
  const context = useContext(ApplicationContext) as AppContext;
  const orderService = context.orderService;
  const appUserService = context.appUserService;
  const organizationService = context.organizationService;
  const refreshService = context.refreshService;

  const [order, setOrder] = useState<Order | null>(null);

  const getOrder = async (orderId: number) => {
    const order = await orderService.GetOrderWithVehicle(orderId);
    const [users, clients, suppliersInit] = await Promise.all([
      appUserService.GetUsersInfo([order.createdBy]),
      organizationService.GetUserOrganizationsByIds([order.clientId]),
      organizationService.GetUserOrganizationsByIds([order.supplierId])
    ]);

    const supplier = suppliersInit.find((item) => item.id === order.supplierId);
    const user = users.find((item) => item.id === order.createdBy);
    const client = clients.find((item) => item.id === order.clientId);

    order.createdByUser = user === undefined ? null : user;
    order.supplier = supplier === undefined ? null : supplier;
    order.client = client === undefined ? null : client;

    setOrder(order);
  };

  const orderChange = (order: Order) => {
    setOrder((prev) => ({
      ...prev!,
      amount: order.amount,
      amountTVA: order.amountTVA,
      amountWithoutTVA: order.amountWithoutTVA,
      orderParts: [...order.orderParts!],
      orderStatus: order.orderStatus,
      orderStatusId: order.orderStatusId
    }));
  };

  useEffect(() => {
    const orderId = Number.parseInt(props.match.params.id);
    if (Number.isNaN(orderId)) {
      return;
    }

    getOrder(orderId);

    const sub = refreshService.OrdersToRefresh$().subscribe((orders: number[]) => {
      if (orders.includes(orderId)) {
        getOrder(orderId);
      }
    });

    return () => sub.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (order === null) {
    return null;
  }

  return (
    <OrderDetailsNew
      onOrderChange={orderChange}
      orderDetails={order}
      hasRights={true}
      fullBleed
      additionTariff={{ id: 0, value: 0 } as TariffPercentResponse}
      discountTariff={{ id: 0, value: 0 } as TariffPercentResponse}
      automatePlaceOrder={false}
      workflowAutomatePlaceOrder={false}
      automatePlaceOrderChange={async () => {
        console.log('automatePlaceOrderChange');
      }}
      onOrderPlacedSuccessfully={() => {
        console.log('onOrderPlacedSuccessfully');
      }}
    />
  );
};

export default connect(
  (state: ApplicationState) => {
    return { caseSettingsState: state.caseSettings, vehicleState: state.vehicle, appState: state.app };
  },
  { ...CaseSettingsActionCreators, ...VehicleActionCreators }
)(withSnackbar(OrderPageNew as any));
